import {Layout} from 'components/layout';
import React from 'react';
import {YMaps, Map, Placemark} from '@pbe/react-yandex-maps';
import {PHONE} from "../../../lib/contants";

export const Contacts = () => {
  return (
    <section
      id='contacts'
      className="font-open-sans mt-[100px] pb-10 bg-plt-secondary/50 rounded-t-[40px] screen-900:rounded-none screen-900:mt-5">
      <Layout.Container>
        <div className="px-[33px] pt-10 screen-700:px-0">
          <h3 className="uppercase font-bold text-center text-plt-black text-[32px] leading-[120%] screen-700:text-lg">
            Контакты
          </h3>
          <div className="pt-[90px] flex gap-10 screen-900:grid screen-900:pt-[50px]">
            <div className="p-8 bg-plt-white rounded-[20px] max-w-[533px] w-full screen-900:max-w-full">
              <h5 className="text-2xl text-plt-black font-bold screen-700:text-base">
                Офис продаж:
              </h5>
              <p className="text-xl text-plt-black font-semibold mt-8 screen-700:text-base">
                Адрес: г. Москва, п. совхоза Крёкшино, ул. Озерная, д. 2, ТЦ «Ярмарка Крекшино»
              </p>
              <p className="text-xl text-plt-black font-semibold mt-8 screen-700:text-base">
                Телефон: <a className='roistat_kr' href={`tel:${PHONE.replaceAll('(', '')
                .replaceAll(')', '')
                .replaceAll('-', '')
                .replaceAll('+', '')
                .replaceAll(' ', '')
              }`}>{PHONE}</a>
              </p>
              <p className="text-xl text-plt-black font-semibold mt-5 screen-700:text-base">
                График работы: ежедневно с 09:00 до 21:00.
              </p>
            </div>

            <div className="w-full rounded-[20px] overflow-hidden min-h-[320px]">
              <YMaps query={{load: 'package.full'}}>
                <Map
                  defaultState={{
                    center: [55.596852, 37.114715],
                    zoom: 16,
                  }}
                  width="100%"
                  height="320px"
                >
                  <Placemark
                    geometry={[55.596852, 37.114715]}
                    properties={{
                      hintContent: 'Офис продаж',
                      balloonContent: 'г. Москва, Крёкшино, ул. Озерная, д. 2',
                    }}
                    options={{
                      preset: 'islands#redIcon',
                    }}
                  />
                </Map>
              </YMaps>
            </div>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
